export default __webpack_public_path__ + "static/media/Add.147f0404.svg";